module.exports = __webpack_public_path__ + "static/media/cs_icon.1de85139.png";